import { render, staticRenderFns } from "./TicketStatsModal.vue?vue&type=template&id=6a0c0a13&scoped=true&"
import script from "./TicketStatsModal.vue?vue&type=script&lang=js&"
export * from "./TicketStatsModal.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatsModal.vue?vue&type=style&index=0&id=6a0c0a13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c0a13",
  null
  
)

export default component.exports